export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    slug: 'zhize-quanxian',
    name: '职责与权限',
    description: '全面解析第一版主的职责范围与权限体系，帮助版主候选人清晰了解角色定位与权责边界。',
    icon: 'ri-shield-check-line',
    articleCount: 8,
  },
  {
    slug: 'renming-liucheng',
    name: '任命流程',
    description: '详解第一版主的任命条件、选拔标准与任命流程，为论坛运营者提供规范化管理参考。',
    icon: 'ri-user-star-line',
    articleCount: 6,
  },
  {
    slug: 'guanli-jiqiao',
    name: '管理技巧',
    description: '分享版块日常运营管理的实用技巧，从内容审核到用户互动，全面提升社区管理效率。',
    icon: 'ri-settings-3-line',
    articleCount: 10,
  },
  {
    slug: 'shequ-yunying',
    name: '社区运营',
    description: '聚焦社区文化建设、用户成长体系与版块活跃度提升策略，打造高质量论坛社区。',
    icon: 'ri-group-line',
    articleCount: 7,
  },
  {
    slug: 'jinsheng-zhinan',
    name: '晋升指南',
    description: '从普通版主到第一版主的完整晋升路径，涵盖能力培养、业绩积累与考核要点。',
    icon: 'ri-bar-chart-2-line',
    articleCount: 5,
  },
  {
    slug: 'anli-fenxi',
    name: '案例分析',
    description: '真实论坛版块管理案例分析，从成功经验与失败教训中提炼可复用的管理方法论。',
    icon: 'ri-file-list-3-line',
    articleCount: 4,
  },
];